import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 28, restDelta: 0.001 });
  return (
    <motion.div
      className="fixed top-0 inset-x-0 h-[3px] bg-[#B85D2A] origin-left z-[70]"
      style={{ scaleX }}
      data-testid="scroll-progress"
    />
  );
};
